import { createAction } from "@reduxjs/toolkit";

export const fetchSsoData = createAction('settings/sso/FETCH_DATA');

export const activateToken = createAction<string>('settings/sso/ACTIVATE_TOKEN');

export const inspectCodeB = createAction<string>('settings/sso/INSPECT_CODE_B');
